import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ShopState, Shop } from "../../types";

const initialState: ShopState = [];

const shopSlice = createSlice({
  name: "shops",
  initialState,
  reducers: {
    addShop(state, action: PayloadAction<Shop>) {
      if (Array.isArray(state)) {
        state.push(action.payload);
      }
    },
    setShops(state, action: PayloadAction<Shop[]>) {
      return action.payload;
    },
    resetShops() {
      return [];
    },
  },
});

export const { setShops, addShop, resetShops } = shopSlice.actions;
export default shopSlice.reducer;
